<template>
  <div>
    <el-card shadow="always">
      <EditForm
        ref="editForm"
        :disabled="true"
        :materialAbnormalCode="params.code"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'financial-financial-userMaterialAbnormal-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
  },
}
</script>
